import { useCallback, useEffect, useRef, useState } from 'react';
import Quiz, { type Round } from './Quiz';
import { BlurCover, REVEAL_MS, STEP_SCORE } from './Reveal';
import { entriesOf, options, preload, prefersReducedMotion, ROUNDS, sample, type Entry } from './game';

const pool = entriesOf('Bands').filter(e => e.image);

type CoverRound = Round & { entry: Entry };

const makeRounds = (): CoverRound[] => sample(pool, ROUNDS).map(entry => ({
  key: entry.name, entry, answer: entry.name, options: options(entry),
}));

export default function BlurryCover({ onExit }: { onExit: () => void }) {
  const [stepped] = useState(prefersReducedMotion);
  const stepRef = useRef(0);
  const onStep = useCallback((n: number) => { stepRef.current = n; }, []);

  useEffect(() => preload(pool), []);

  return (
    <Quiz<CoverRound>
      game="blur"
      makeRounds={makeRounds}
      maxScore={ROUNDS * STEP_SCORE[0]}
      scoreFor={ms => stepped ? STEP_SCORE[stepRef.current] : Math.max(1, Math.ceil((REVEAL_MS - ms) / 1000))}
      renderStage={(round, answered) => (
        <div className={`reveal-stage${stepped ? ' is-stepped' : ''}`}>
          <span className="game-label">Which band is this?</span>
          <BlurCover key={round.key} entry={round.entry} answered={answered} stepped={stepped} onStep={onStep} />
        </div>
      )}
      verdict={({ score }) =>
        score >= ROUNDS * STEP_SCORE[0] * 0.7 ? 'Eagle eyes. You have clearly been through my records.'
          : score >= ROUNDS * STEP_SCORE[0] * 0.4 ? 'Not bad at all.'
            : 'Blurry indeed. Insert coin and try again?'}
      onExit={onExit}
    />
  );
}
